 // 別タブリンクに対してnoreferrer noopenerを追記
 document.addEventListener('DOMContentLoaded', function(){
  // すべての a[target="_blank"] 要素を選択します
  const links = document.querySelectorAll('a[target="_blank"]');

  // 各リンクに対して処理を行います
  links.forEach(link => {
    // rel 属性が既に設定されていない場合
    if (!link.hasAttribute('rel')) {
      // noreferrer noopener を追加します
      link.setAttribute('rel', 'noreferrer noopener');
    }
  });
});

// ヘッダー分paddingを入れる
document.addEventListener('DOMContentLoaded', function(){
  // ヘッダーの要素を取得
  var header = document.querySelector('header');
  // .p-main-visual の要素を取得
  var mainVisual = document.querySelector('main');// このセレクタは適宜変更してください
  var globalNav = document.querySelector('#global-nav');// このセレクタは適宜変更してください
  function updatePadding() {
      var style = window.getComputedStyle(header);
      // ヘッダーの position が fixed であるかチェック
      if (style.position === 'fixed') {
          var headerHeight = header.offsetHeight; // ヘッダーの高さを取得
          mainVisual.style.paddingTop = headerHeight + 'px'; // ヘッダーの高さを padding-top に設定
          globalNav.style.top = headerHeight + 'px'; // ヘッダーの高さを top に設定
      } else {
          mainVisual.style.paddingTop = '0px'; // ヘッダーが fixed でない場合は padding-top をリセット
          globalNav.style.top = '0px'; // ヘッダーが fixed でない場合は padding-top をリセット
      }
  }
  // ページ読み込み時とウィンドウサイズ変更時に updatePadding 関数を呼び出す
  window.onload = updatePadding;
  window.onresize = updatePadding;
});

// グローバルメニュートグルボタン開閉処理
    //ドロワーメニュー制御
    document.addEventListener('DOMContentLoaded', function() {
      const navToggle = document.querySelector('#js-nav-toggle');
      const globalNav = document.querySelector('#global-nav');
      const body = document.body;
  
      // #js-nav-toggleをクリックした際の処理
      navToggle.addEventListener('click', function() {
          this.classList.toggle('is-active');
          globalNav.classList.toggle('is-show');
          body.classList.toggle('is-scroll_off');
      });
  
      // #global-nav内のコンテンツをクリックした際の処理
      globalNav.addEventListener('click', function() {
          navToggle.classList.remove('is-active');
          this.classList.remove('is-show');
          body.classList.remove('is-scroll_off');
      });
  
      // 画面サイズが1200px以上になった際の処理
      window.addEventListener('resize', function() {
          if (window.innerWidth >= 1200) {
              navToggle.classList.remove('is-active');
              globalNav.classList.remove('is-show');
              body.classList.remove('is-scroll_off');
          }
      });
  });

// スムーススクロール
document.addEventListener('DOMContentLoaded', function() {
  // headerの高さを取得し、headeHeightに代入
  const headerHeight = document.querySelector('header').offsetHeight;
  //querySelectorAllメソッドを使用してページ内のhref属性が#で始まるものを選択
  //forEachメソッドを使って、各アンカータグにクリックされた時の処理
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {

      // クリックされたときのデフォルトの挙動を防ぐ
      e.preventDefault();
      // クリックされたアンカータグのhref属性を取得
      const href = anchor.getAttribute('href');
      // href属性の#を取り除いた部分と一致するIDを取得
      const target = document.getElementById(href.replace('#', ''));
      //取得した要素の位置を取得するために、getBoundingClientRect()を呼び出し、ページ上の位置を計算。
      //headerの高さを引いて、スクロール位置がヘッダーの下になるように調整します。
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      // window.scrollTo()を呼び出して、スクロール位置を設定します。behaviorオプションをsmoothに設定することで、スムーズなスクロールを実現します。
      window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
      });
    });
  });
});


//ページ内ナビゲーション カレント表示
// document.addEventListener('DOMContentLoaded', () => {
//   const headerHeight = document.querySelector('header').offsetHeight;
//   const navLinks = document.querySelectorAll('#global-nav a'); // ナビゲーションリンクを選択

//   function onScroll() {
//       let found = false;
//       navLinks.forEach((link) => {
//           if (found) return;
//           const sectionId = link.getAttribute('href').substring(1);
//           const section = document.getElementById(sectionId);
//           if (section) {
//               const rect = section.getBoundingClientRect();
//               const top = rect.top;
//               const bottom = rect.bottom;
//               // ビューポート内にセクションがあるかチェック
//               if (top <= headerHeight && bottom >= headerHeight) {
//                   link.classList.add('is-current');
//                   found = true; // 一つ見つかったら他はチェックしない
//               } else {
//                   link.classList.remove('is-current');
//               }
//           }
//       });
//   }
//   window.addEventListener('scroll', onScroll);
// });


document.addEventListener('DOMContentLoaded', function(){
  const mySwiper = new Swiper('#js-top-mv-slider', {
    loop: true,
    updateOnWindowResize: true,
    followFinger:true,
    passiveListeners:true,
    loopedSlides:3,
    //disableOnInteraction: false,
    //waitForTransition: false,
    //mousewheel: false,
    //slideToClickedSlide: true,
    spaceBetween: 0,
    slidesPerView: 1,
    loopedSlides:6,
    autoplay: { // 自動再生
      delay: 3000, // 1秒後に次のスライド
      disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
    },
    breakpoints: {
      1020: {
        centeredSlides: true, // アクティブなスライドを中央にする
        slidesPerView: 1.67,
      }, 
      600: {
        centeredSlides: true, // アクティブなスライドを中央にする
        slidesPerView: 1.25,
      },
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const mySwiper2 = new Swiper('#js-top-recipe-slider', {
    loop: true,
    updateOnWindowResize: true,
    followFinger:true,
    passiveListeners:true,
    //disableOnInteraction: false,
    //waitForTransition: false,
    //mousewheel: false,
    //slideToClickedSlide: true,
    spaceBetween: 30,
    slidesPerView: 1,
    centeredSlides: false, // アクティブなスライドを中央にする
    autoplay: { // 自動再生
      delay: 3000, // 1秒後に次のスライド
      disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
    },
    breakpoints: {
      901: {
        slidesPerView: 3,
      },
      601: {
        slidesPerView: 2,
      },
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

});
});

document.addEventListener('DOMContentLoaded', function() {
  var rankingSwiper;
  var voiceSwiper;

  function initOrUpdateSwiper() {
      var w = window.innerWidth;

      // rankingSwiperの初期化または破棄
      if (w <= 600) {
          if (!rankingSwiper) {
              rankingSwiper = new Swiper('#js-top-ranking-slider', {
                  loop: true,
                  slidesPerView: 1,
                  updateOnWindowResize: true,
                  followFinger:true,
                  passiveListeners:true,
                  spaceBetween: 30,
                  autoplay: {
                    delay: 3000, // 1秒後に次のスライド
                    disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
                  },       
                  navigation: {
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                  },
              });
          }
      } else {
          if (rankingSwiper) {
              rankingSwiper.destroy();
              rankingSwiper = undefined;
          }
      }

      // voiceSwiperの初期化または破棄
      if (w <= 600) {
          if (!voiceSwiper) {
              voiceSwiper = new Swiper('#js-top-voice-slider', {
                  loop: true,
                  slidesPerView: 1,
                  updateOnWindowResize: true,
                  followFinger:true,
                  passiveListeners:true,
                  spaceBetween: 30,
                  autoHeight: true,
                  autoplay: {
                    delay: 3000, // 1秒後に次のスライド
                    disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
                  },  
                  navigation: {
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                  },
              });
          }
      } else {
          if (voiceSwiper) {
              voiceSwiper.destroy();
              voiceSwiper = undefined;
          }
      }
  }

  // ウィンドウのロードとリサイズイベントでSwiperを初期化または更新
  window.addEventListener('load', initOrUpdateSwiper);
  window.addEventListener('resize', initOrUpdateSwiper);
});


//タブ切り替え
document.addEventListener('DOMContentLoaded', function(){
  // タブに対してクリックイベントを適用
  const tabs = document.getElementsByClassName('tab');
  for(let i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener('click', tabSwitch, false);
  }

  // タブをクリックすると実行する関数
  function tabSwitch(){
    // タブのclassの値を変更
    document.getElementsByClassName('is-active')[0].classList.remove('is-active');
    this.classList.add('is-active');
    // コンテンツのclassの値を変更
    document.getElementsByClassName('is-show')[0].classList.remove('is-show');
    const arrayTabs = Array.prototype.slice.call(tabs);
    const index = arrayTabs.indexOf(this);
    document.getElementsByClassName('panel')[index].classList.add('is-show');
  };
}, false);


// .js-sub-nav_btnクラスを持つ全ての要素に対してイベントリスナーを設定
document.querySelectorAll('.js-sub-nav_btn').forEach(function(button) {
  button.addEventListener('click', function() {
      // この要素の親のli要素を見つける
      var parentLi = this.closest('li');

      // 親のliが存在する場合、.is-activeクラスをトグルする
      if (parentLi) {
          parentLi.classList.toggle('is-active');
      }
  });
});

window.addEventListener('load', function() {
  if(!localStorage.getItem('disp_popup')) {
      const dispPopup = function() {
          localStorage.setItem('disp_popup', 'on');
          const body = document.querySelector('body');
          const bgPopup = document.querySelector('.p-onetime_popup_bg');
          const popup = document.querySelector('.p-onetime_popup');
          const popupTitleClose = document.querySelector('.p-onetime_popup_close');
          body.classList.add('open_popup');

          bgPopup.addEventListener('click', function() {
              closePopup();
          });
          popup.addEventListener('click', function(e) {
              e.stopPropagation();
          });
          popupTitleClose.addEventListener('click', function() {
              closePopup();
          });

          function closePopup() {
              body.classList.remove('open_popup');
          }
      };
      setTimeout(dispPopup, 3000);
  }
}, false);